import { TeamsService } from '@/services';

const INITIAL_STATE = {
  isLoadingTeams: false,
  isLoadingTeam: false,
  isLoadingTasks: false,
  project: null,
  teams: null,
};

const store = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    SET_TEAMS(state, value) {
      state.teams = value;
    },

    SET_LOADING_TEAMS(state, value) {
      state.isLoadingTeams = value;
    },

    SET_LOADING_TEAM(state, value) {
      state.isLoadingTeam = value;
    },

    SET_LOADING_TASKS(state, value) {
      state.isLoadingTasks = value;
    },
  },
  actions: {
    async fetchTeams({ commit }, companyId) {
      commit('SET_LOADING_TEAMS', true);

      const teams = await TeamsService.fetchCompanyTeams(companyId);

      commit('SET_TEAMS', teams);

      commit('SET_LOADING_TEAMS', false);
    },
    createTeam() {},
    updateTeamInfo() {},
    addTeamMember() {},
    removeTeamMember() {},
  },
};

export default store;
